/**
 * Lite 專用 JWT 管理（單一來源）
 *
 * - 讀取時優先 localStorage，其次 sessionStorage。
 * - 寫入時同時更新 localStorage 與 sessionStorage，避免舊值殘留。
 * - 不直接處理 URL query；由各頁在解析完 URL 後呼叫 setLiteJwtToken。
 */

const STORAGE_KEY = 'jwt_token';

/**
 * 取得 Lite JWT；若不存在則回傳 null。
 */
export function getLiteJwtToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    const fromLocal = window.localStorage.getItem(STORAGE_KEY);
    if (fromLocal) return fromLocal;

    const fromSession = window.sessionStorage.getItem(STORAGE_KEY);
    if (fromSession) return fromSession;
  } catch {
    // 某些環境（隱私模式）可能禁止存取 storage，直接視為沒有 token
  }
  return null;
}

/**
 * 設定 Lite JWT；同時寫入 localStorage 與 sessionStorage。
 */
export function setLiteJwtToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // 忽略 localStorage 錯誤
  }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // 忽略 sessionStorage 錯誤
  }
}

/**
 * 清除 Lite JWT；用於 401 或 debug 重置。
 */
export function clearLiteJwtToken(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
  try {
    window.sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
